/* eslint-disable */
import { windowStore } from 'util/windowStore';
import { Headers, resetCache } from './';
import { getAuth0Token } from '../auth0';

/**
 * Function will retrieve and return either:
 * 1. JWT for legacy-auth user or SSO user; or
 * 2. Auth0 Access-token and id-token for IAM user
 *
 * If token is expired/removed user's session will be nulled.
 */
export async function getToken(conf) {
  const resp = { accessToken: null, idToken: null, jwt: null };
  if (windowStore.auth0) {
    try {
      const { accessToken, idToken } = await getAuth0Token();
      resp.accessToken = accessToken;
      resp.idToken = idToken;
      if (conf) {
        conf.headers[Headers.Authorization] = `Bearer ${accessToken}`;
        conf.headers[Headers.UserInfo] = idToken;
        delete conf.headers[Headers.SessionToken];
      }
    } catch (err) {
      resetCache();
      return Promise.reject(err);
    }
  } else {
    const jwt = windowStore.getToken();
    if (!jwt) {
      resetCache();
      return Promise.reject({ message: 'token invalidated.' });
    }
    if (conf) {
      conf.headers[Headers.SessionToken] = jwt;
      delete conf.headers[Headers.Authorization];
      delete conf.headers[Headers.UserInfo];
    }
    resp.jwt = jwt;
  }
  return resp;
}
